import React from 'react';
import { motion } from 'framer-motion';
import './Hero.css';
import profileImage from '../assets/profile.jpg';

const Hero = () => {
  const stats = [
    { number: '10+', label: 'Years in AI/ML' },
    { number: '3', label: 'Patents Filed' },
    { number: '5', label: 'Enterprise POCs' },
    { number: '3', label: 'AI Ventures Founded' },
  ];

  // Reordered: Impact first (most important to stakeholders), then Ethics, then Scale
  const iesPillars = [
    { letter: 'I', word: 'Impactful', desc: 'Measurable business outcomes' },
    { letter: 'E', word: 'Ethical', desc: 'Responsible data usage' },
    { letter: 'S', word: 'Scalable', desc: 'Production-ready systems' },
  ];

  return (
    <section id="hero" className="hero">
      <div className="hero-background">
        <div className="hero-gradient"></div>
        <div className="hero-pattern"></div>
        <div className="hero-orbs">
          <div className="orb orb-1"></div>
          <div className="orb orb-2"></div>
          <div className="orb orb-3"></div>
        </div>
      </div>

      <div className="hero-container">
        <div className="hero-main">
          <motion.div
            className="hero-content"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
          <motion.div
            className="hero-badge"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <span className="badge-dot"></span>
            AI/ML Technical Product Manager @ IBM
          </motion.div>

          <h1 className="hero-title">
            <span className="title-line">Arjun</span>
            <span className="title-line title-accent">Banerjee</span>
          </h1>

          <h2 className="hero-subtitle">
            AI Product Architect
          </h2>
          <p className="hero-tagline">
            <em>From Data to Model to Product</em>
          </p>

          <p className="hero-description">
            I help organizations <strong>build AI products that drive real business outcomes</strong>—designed 
            responsibly and scaled for enterprise. With <strong>10+ years of management experience</strong> and <strong>deep technical expertise</strong>, I can help design and ideate end-to-end ML/GenAI solutions across 
            Healthcare, Finance, and Telecom.
          </p>

          <motion.div
            className="hero-eis"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
          >
            <span className="eis-label">The IES Framework™</span>
            <div className="eis-pillars">
              {iesPillars.map((pillar, index) => (
                <div key={index} className="eis-pillar">
                  <span className="eis-letter">{pillar.letter}</span>
                  <div className="eis-text">
                    <span className="eis-word">{pillar.word}</span>
                    <span className="eis-desc">{pillar.desc}</span>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            className="hero-cta"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8 }}
          >
            <a href="https://meetings-na2.hubspot.com/banerjeearjun73/consultation-call-intro" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-large">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/>
                <line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
              Book Free Consultation
            </a>
            <a href="/Arjun_Banerjee_Resume.pdf" target="_blank" rel="noopener noreferrer" className="btn btn-ghost">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="16" y1="13" x2="8" y2="13"/>
                <line x1="16" y1="17" x2="8" y2="17"/>
                <polyline points="10 9 9 9 8 9"/>
              </svg>
              Download CV
            </a>
          </motion.div>
        </motion.div>

          <motion.div
            className="hero-image"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <div className="image-wrapper">
              <img src={profileImage} alt="Arjun Banerjee" />
              <div className="image-decoration"></div>
            </div>
          </motion.div>
        </div>

        <motion.div
          className="hero-stats"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1 }}
        >
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              className="stat-item"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.2 + index * 0.1 }}
            >
              <span className="stat-number">{stat.number}</span>
              <span className="stat-label">{stat.label}</span>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="hero-scroll"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5 }}
        >
          <a href="#about" className="scroll-indicator">
            <span>Scroll to explore</span>
            <div className="scroll-mouse">
              <div className="scroll-wheel"></div>
            </div>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;

